import { render, staticRenderFns } from "./ManageRoles.vue?vue&type=template&id=eafc8d58&scoped=true&"
import script from "./ManageRoles.vue?vue&type=script&lang=js&"
export * from "./ManageRoles.vue?vue&type=script&lang=js&"
import style0 from "./ManageRoles.vue?vue&type=style&index=0&id=eafc8d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafc8d58",
  null
  
)

export default component.exports